// actions/tabActions.js
export const setActiveTabIndex = (index) => ({
    type: "SET_ACTIVE_TAB_INDEX",
    payload: index,
});
